


import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Configuration } from '../../app.constants';

@Injectable()
export class MeasureUnitService {

    private actionUrl: string;

    constructor(private http: HttpClient, _configuration: Configuration) {
        this.actionUrl = _configuration.apiBase + 'measure_unit/';
    }

    public getAll<T>(): Observable<T> {
        return this.http.get<T>(this.actionUrl);
    }
}
